import { render } from "./BrowserStat.vue?vue&type=template&id=3cb2d073"
import script from "./BrowserStat.vue?vue&type=script&lang=js"
export * from "./BrowserStat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__